import { isApiError } from '../api/fetch/apiClient';
import { SHOP_NOT_OPEN_ERROR } from '../api/types';

/**
 * Login, registration and guest creation refuse with a 403 and this key when
 * the shop is not open to the requester (spec 2026-10-22-remove-sandbox-mode
 * §6.3) — so the UI can say so instead of "wrong password". A login or guest
 * flow's error toast uses `orShopNotOpen(error, ownKey)`.
 */
export const isShopNotOpenError = (error: unknown): boolean =>
  isApiError(error) &&
  error.status === 403 &&
  (error.body as { error?: string } | undefined)?.error === SHOP_NOT_OPEN_ERROR;

export const orShopNotOpen = (error: unknown, fallback: string): string =>
  isShopNotOpenError(error) ? SHOP_NOT_OPEN_ERROR : fallback;
